import { FormInputField } from '@/src/components/common'
import { Box } from 'grommet'

type Props = {
  step: number
}

const PricingStep = (props: Props) => {
  const { step } = props
  return (
    <div
      className={`step-slide ${step === 2 ? 'active' : ''}`}
      style={{
        position: 'absolute',
        transform: `translateX(${step === 2 ? '0' : step < 2 ? '100%' : '-100%'})`,
        transition: 'all 0.3s ease-in-out',
        width: '100%'
      }}
    >
      {/* Step 2: Pricing */}
      <Box className="!min-h-[auto]" direction="column" gap="medium">
        <FormInputField label="Mark up Percentage" name="mark_up_percentage" placeholder="Mark up Percentage" />
        <FormInputField label="VAT Percentage (Optional)" name="vat_percentage" placeholder="VAT Percentage" />
      </Box>
    </div>
  )
}

export default PricingStep
